<template>
  <div class="outer-page">
    <div class="center-width">
      <div class="content">
        <div class="search-box">
          <div class="search-item">
            <div class="label">发布时间：</div>
            <div class="search-item-time">
              <div
                :style="{
                  width: '20rem',
                  position: 'relative',
                  left: `${piexl}rem`,
                }"
              >
                <span
                  :class="[
                    'condition-name',
                    search_data.beginType === item.type
                      ? 'condition-name-active'
                      : '',
                  ]"
                  @click="() => (search_data.beginType = item.type)"
                  v-for="item in releaseTime"
                  :key="item.name"
                  >{{ item.name }}</span
                >
              </div>
            </div>
          </div>
          <div class="search-item">
            <div class="label">筛选条件：</div>
            <span
              :class="[
                'condition-name',
                search_data.applyStatus === item.type
                  ? 'condition-name-active'
                  : '',
              ]"
              @click="() => (search_data.applyStatus = item.type)"
              v-for="item in condition"
              :key="item.name"
              >{{ item.name }}</span
            >
          </div>
          <div class="search-item">
            <div class="label">分类：</div>
            <span
              :class="[
                'condition-name',
                search_data.classifyId === item.type
                  ? 'condition-name-active'
                  : '',
              ]"
              @click="() => (search_data.classifyId = item.type)"
              v-for="item in classify"
              :key="item.name"
              >{{ item.name }}</span
            >
          </div>
          <div class="search-item">
            <div class="label">关键词：</div>
            <Input
              v-model="name"
              search
              enter-button
              style="width: 10rem; margin: 0 0.2rem"
              @on-search="search"
            ></Input>
          </div>
        </div>
        <div class="bidding-list-box">
          <div class="list-header">
            <span>招标名称</span>
            <span>发布日期</span>
          </div>
          <ul>
            <li
              class="list-item"
              v-for="item in biddingList"
              :key="item.id"
              :title="item.name"
              @click="() => goThere('biddingInfo', item.id)"
            >
              <div class="list-item-title">
                <span class="title">{{ item.name }}</span>
                <span class="date">{{ item.beginTime.split(" ")[0] }}</span>
              </div>
              <div class="list-item-info">
                <div>
                  <span>招标方式：</span>
                  <span class="result">{{ item.biddingTypeName }}</span>
                </div>
                <div>
                  <span>报名截止时间：</span>
                  <span class="result">{{ item.applyEndTime }}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="list-footer">
            <Page
              :current="page.pageNo"
              :page-size="page.pageSize"
              :total="page.total"
              :show-elevator="true"
              :show-total="true"
              @on-change="pageChange"
              size="small"
            ></Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      releaseTime: [
        { name: "全部", type: "" },
        { name: "今天", type: 1 },
        { name: "最近3天", type: 2 },
        { name: "最近7天", type: 3 },
        { name: "最近1个月", type: 4 },
        { name: "最近3个月", type: 5 },
      ],
      condition: [
        { name: "全部", type: "" },
        { name: "报名中", type: 1 },
        { name: "报名结束", type: 2 },
      ],
      classify: [
        { name: "全部", type: "" },
        { name: "工程", type: 1 },
        { name: "货物", type: 2 },
        { name: "服务", type: 3 },
      ],
      search_data: {
        beginType: "",
        applyStatus: "",
        classifyId: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      biddingList: [],
      name: "",
      piexl: 0,
    };
  },
  methods: {
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getList();
    },

    search() {
      this.page.pageNo = 1;
      this.getList();
    },

    getList() {
      this.$post(this.$api.BIDDING.LIST, {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        ...this.search_data,
        name: this.name,
      }).then((res) => {
        this.biddingList = res.list;
        this.page.total = +res.total;
      });
    },
    goThere(router, id) {
      this.$router.push({
        name: "mbiddingInfo",
        query: { bidId: JSON.stringify(id) },
      });
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    search_data: {
      handler(n) {
        this.page.pageNo = 1;
        this.getList();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.outer-page {
  width: 100%;
  padding: 0.5rem 0;
  font-size: 0.577rem;
  line-height: 1rem;
  .center-width {
    width: 94%;
    margin: 0 3%;
    .content {
      font-size: 0.577rem;
      line-height: 0.88rem;
      color: #666666;
      padding-top: 0.5rem;
      .search-box {
        .search-item {
          display: flex;
          align-items: flex-start;
          margin-top: 0.2rem;
          .label {
            font-weight: bold;
            width: 4.1rem;
            text-align: right;
            padding-right: 0.95rem;
            color: #333;
          }
          .search-item-time {
            width: 10rem;
            // overflow: hidden;
            display: flex;
            flex-wrap: wrap;
          }
          .condition-name {
            padding: 0.1rem 0.2rem;
            margin: 0 0.2rem;
            // border: 1px solid red;
          }
          .condition-name-active {
            color: #fff;
            // background: #ff9c00;
            background: #2d8cf0;
          }
        }
      }
      .bidding-list-box {
        margin-top: 1rem;
        width: 100%;
        .list-header {
          background: #f9f9f9;
          font-weight: bold;
          height: 1.5rem;
          line-height: 1.5rem;
          border-bottom: 0.04rem #f0f0f0 solid;
          border-top: 0.04rem #f0f0f0 solid;
          color: #333;
          display: flex;
          justify-content: space-between;
          span {
            padding: 0 0.8rem;
            display: inline-block;
            width: 6rem;
            text-align: center;
            &:last-child {
              border-left: 0.04rem #f0f0f0 solid;
            }
          }
        }
        ul {
          .list-item {
            border-bottom: 0.04rem #f2f2f2 solid;
            padding: 0.8rem 0.4rem;
            overflow: hidden;
            .list-item-title {
              display: flex;
              justify-content: space-between;
              .title {
                color: #000;
                display: inline-block;
                width: 8.5rem;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .date {
                display: inline-block;
                width: 4.5rem;
                text-align: center;
                font-weight: bold;
                color: #999;
              }
            }
            .list-item-info {
              //   display: flex;
              padding-top: 0.4rem;
              > div {
                color: #666;
                .result {
                  color: #999;
                }
              }
            }
          }
        }
        .list-footer {
          text-align: center;
          padding: 0.8rem 0;
        }
      }
    }
  }
}
</style>